import { render, staticRenderFns } from "./ErrorOverlay.vue?vue&type=template&id=6c8c487b&scoped=true&"
import script from "./ErrorOverlay.vue?vue&type=script&lang=js&"
export * from "./ErrorOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ErrorOverlay.vue?vue&type=style&index=0&id=6c8c487b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8c487b",
  null
  
)

export default component.exports